// Generated by `yarn tokens:import --aos-ds` from the Figma component set "DetailsListItem" (6943:126824). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const detailslistitemContract = {
    component: 'DetailsListItem',
    nodeId: '6943:126824',
    section: '[Web] Emergency events',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'Action', variants: ['state=default-accept', 'state=default-reject'] },
        { component: 'Check', variants: [] },
        { component: 'DetailsListItemPart', variants: ['type=value'] },
        { component: 'Error', variants: [] },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    textStyleIds: ['S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,'],
    props: {
        instance: { kind: 'instance_swap' },
        label: { kind: 'text' },
        showIcons: { kind: 'boolean' },
        showLeftIcon: { kind: 'boolean' },
        type: { kind: 'enum', values: ['short', 'long'] },
    },
    variants: {
        'type=long': {
            container: 'w-[20.4375rem] items-start justify-between',
            label: 'text-content-muted text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'content': 'gap-xs items-start',
                'details-list-item-part': 'gap-s items-center',
                'Vector': 'w-[1.0417rem] h-[1.0417rem]',
                '#label': 'text-content-muted text-left',
                'DetailsListItemPart': 'pl-3xl gap-s items-center',
                'icons': 'gap-s items-center',
                'Action': 'rounded-common w-[1.5rem] h-[1.5rem] items-center justify-center',
                'Action 2': 'rounded-common w-[1.5rem] h-[1.5rem] items-center justify-center',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I9084:64908;46:1266',
                    width: 17,
                    height: 17,
                    paths: [
                        {
                            d: 'M8.77404 4.14663V8.53365L12.52 10.7572L11.899 11.8189L7.51202 9.15465V4.14663H8.77404ZM8.33333 15.024C9.53526 15.024 10.657 14.7169 11.6987 14.1026C12.7137 13.515 13.515 12.7137 14.1026 11.6987C14.7169 10.657 15.024 9.53526 15.024 8.33333C15.024 7.1314 14.7169 6.00962 14.1026 4.96795C13.515 3.95299 12.7137 3.15171 11.6987 2.5641C10.657 1.94978 9.53526 1.64263 8.33333 1.64263C7.1314 1.64263 6.00962 1.94978 4.96795 2.5641C3.95299 3.15171 3.15171 3.95299 2.5641 4.96795C1.94978 6.00962 1.64263 7.1314 1.64263 8.33333C1.64263 9.53526 1.94978 10.657 2.5641 11.6987C3.15171 12.7137 3.95299 13.515 4.96795 14.1026C6.00962 14.7169 7.1314 15.024 8.33333 15.024ZM8.33333 0C9.85578 0 11.2647 0.380605 12.5601 1.14183C13.8154 1.86298 14.8037 2.85122 15.5248 4.10657C16.2861 5.40198 16.6667 6.81089 16.6667 8.33333C16.6667 9.85578 16.2861 11.2647 15.5248 12.5601C14.8037 13.8154 13.8154 14.8037 12.5601 15.5248C11.2647 16.2861 9.85578 16.6667 8.33333 16.6667C6.81089 16.6667 5.40198 16.2861 4.10657 15.5248C2.85122 14.7903 1.86298 13.7954 1.14183 12.5401C0.380605 11.2446 0 9.84242 0 8.33333C0 6.82424 0.380605 5.42201 1.14183 4.1266C1.87634 2.87125 2.87125 1.87634 4.1266 1.14183C5.42202 0.380605 6.82424 0 8.33333 0Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                '#label': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'Action', variants: ['state=default-accept', 'state=default-reject'] },
                { component: 'Check', variants: [] },
                { component: 'DetailsListItemPart', variants: ['type=value'] },
                { component: 'Error', variants: [] },
            ],
        },
        'type=short': {
            container: 'gap-s w-[20.4375rem] items-center',
            label: 'text-content-muted text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'content': 'gap-s items-center',
                'details-list-item-part': 'gap-s items-center',
                'Vector': 'w-[1.0417rem] h-[1.0417rem]',
                '#label': 'text-content-muted text-left',
                'DetailsListItemPart': 'gap-s w-[8.375rem] items-center justify-center',
                'icons': 'gap-s items-center',
                'Action': 'rounded-common w-[1.5rem] h-[1.5rem] items-center justify-center',
                'Action 2': 'rounded-common w-[1.5rem] h-[1.5rem] items-center justify-center',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I9566:129022;46:1266',
                    width: 17,
                    height: 17,
                    paths: [
                        {
                            d: 'M8.77404 4.14663V8.53365L12.52 10.7572L11.899 11.8189L7.51202 9.15465V4.14663H8.77404ZM8.33333 15.024C9.53526 15.024 10.657 14.7169 11.6987 14.1026C12.7137 13.515 13.515 12.7137 14.1026 11.6987C14.7169 10.657 15.024 9.53526 15.024 8.33333C15.024 7.1314 14.7169 6.00962 14.1026 4.96795C13.515 3.95299 12.7137 3.15171 11.6987 2.5641C10.657 1.94978 9.53526 1.64263 8.33333 1.64263C7.1314 1.64263 6.00962 1.94978 4.96795 2.5641C3.95299 3.15171 3.15171 3.95299 2.5641 4.96795C1.94978 6.00962 1.64263 7.1314 1.64263 8.33333C1.64263 9.53526 1.94978 10.657 2.5641 11.6987C3.15171 12.7137 3.95299 13.515 4.96795 14.1026C6.00962 14.7169 7.1314 15.024 8.33333 15.024ZM8.33333 0C9.85578 0 11.2647 0.380605 12.5601 1.14183C13.8154 1.86298 14.8037 2.85122 15.5248 4.10657C16.2861 5.40198 16.6667 6.81089 16.6667 8.33333C16.6667 9.85578 16.2861 11.2647 15.5248 12.5601C14.8037 13.8154 13.8154 14.8037 12.5601 15.5248C11.2647 16.2861 9.85578 16.6667 8.33333 16.6667C6.81089 16.6667 5.40198 16.2861 4.10657 15.5248C2.85122 14.7903 1.86298 13.7954 1.14183 12.5401C0.380605 11.2446 0 9.84242 0 8.33333C0 6.82424 0.380605 5.42201 1.14183 4.1266C1.87634 2.87125 2.87125 1.87634 4.1266 1.14183C5.42202 0.380605 6.82424 0 8.33333 0Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                '#label': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'Action', variants: ['state=default-accept', 'state=default-reject'] },
                { component: 'Check', variants: [] },
                { component: 'DetailsListItemPart', variants: ['type=value'] },
                { component: 'Error', variants: [] },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
